'use client';

import { ArticleCardFragment } from '@/__generated__/graphql';
import { ARTICLE_CARD_FRAGMENT } from '@/gql/fragments/entryCards.gql';
import { useFragment } from '@apollo/client';
import { ArticleCard } from '../Cards/ArticleCard';

export default function ArticleResult({ id }: { id: string }) {
  const { data } = useFragment({
    fragment: ARTICLE_CARD_FRAGMENT,
    fragmentName: 'articleCard',
    from: { id, __typename: 'article_Entry' },
  });

  return <ArticleCard data={data as ArticleCardFragment} />;
}
